module.exports = __webpack_public_path__ + "media/assets/icons/megaphone-icon-purple-9fe0d37805134828a8dc69997f0b6f5c.png";